import correctResponseActions from '../actions/CorrectResponsesActions';

export default function (state = {}, action) {
    switch (action.type) {
    case correctResponseActions.types.CORRECT_RESPONSES_SET:
        return Object.assign({}, action.correctResponses);

    case correctResponseActions.types.CORRECT_RESPONSES_CLEAR:
        return {};

    default:
        return state;
    }
}
